import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getStudentEnrollmentData = async (
  // courseId,
  // studentId,
  enrollmentId
) => {
  const res = await axios.apiCadernoVirtual("/diary-service/enrollment", {
    params: { enrollmentId },
  });
  return res[0];
};

export const useStudentEnrollmentData = ({
  config,
  courseId,
  studentId,
  enrollmentId,
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["studentEnrollmentData", { enrollmentId }],
    queryFn: () => getStudentEnrollmentData(enrollmentId),
  });
};
